import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function CounterargumentHelp({ theme, ...props }) {
  return (
    <svg
      width="28"
      height="25"
      xmlns="http://www.w3.org/2000/svg"
      className={cx(theme.container, theme[props.svg], props.className)}
    >
      <g fill="none" fillRule="evenodd" className={theme.stroke}>
        <path
          d="M10.06 20.363h10.68l4.045 4.044v-4.044h1.66a1.15 1.15 0 0 0 1.14-1.14V7.088a1.15 1.15 0 0 0-1.14-1.14H10.058a1.15 1.15 0 0 0-1.14 1.14v12.03c0 .725.518 1.244 1.14 1.244z"
          fill="#43B02A"
        />
        <path
          d="M19.185 1.593H2.696a1.15 1.15 0 0 0-1.14 1.14v12.03c0 .622.518 1.14 1.14 1.14h1.66v4.045L8.4 15.904h10.681a1.15 1.15 0 0 0 1.141-1.141V2.733c0-.622-.415-1.14-1.037-1.14z"
          stroke="#4A4A4A"
          strokeWidth="2"
          fill="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
CounterargumentHelp.propTypes = {
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
}
